export const SET_LOCALE = 'SET_LOCALE'
export const ADD_LOCALE_MESSAGES = 'ADD_LOCALE_MESSAGES'

export const SHOW_HEADER = 'SHOW_HEADER'
export const HIDE_HEADER = 'HIDE_HEADER'

export const OPEN_SIDE_MENU = 'OPEN_SIDE_MENU'
export const CLOSE_SIDE_MENU = 'CLOSE_SIDE_MENU'

export const SET_RUYI_STOCK_PRICE = 'SET_RUYI_STOCK_PRICE'
export const SET_RUYI_STOCK_CHANGE = 'SET_RUYI_STOCK_CHANGE'
export const SET_RENOWN_STOCK_PRICE = 'SET_RENOWN_STOCK_PRICE'
export const SET_RENOWN_STOCK_CHANGE = 'SET_RENOWN_STOCK_CHANGE'

export const SHOW_SITEMAP_OVERLAY = 'SHOW_SITEMAP_OVERLAY'
export const HIDE_SITEMAP_OVERLAY = 'HIDE_SITEMAP_OVERLAY'
export const SHOW_WECHAT_OVERLAY = 'SHOW_WECHAT_OVERLAY'
export const HIDE_WECHAT_OVERLAY = 'HIDE_WECHAT_OVERLAY'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js